<script setup lang="ts">
  import { Icon, type IconName, IconSize } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';
  import { CONFIRMATION_TYPE_ICONS } from '../config/icons';
  import type { ConfirmationType } from '../model/types';

  interface ConfirmationTypeIconProps {
    type: ConfirmationType;
    size?: `${IconSize}`;
  }

  const props = withDefaults(defineProps<ConfirmationTypeIconProps>(), {
    size: IconSize.M,
  });

  const icon = computed<`${IconName}`>(() => CONFIRMATION_TYPE_ICONS[props.type]);
</script>

<template>
  <Icon
    :class="['confirmation-type-icon', `confirmation-type-icon_${type}`]"
    :name="icon"
    :size="size"
    data-testid="confirmation-type-icon"
  />
</template>

<style scoped lang="scss">
  .confirmation-type-icon {
    flex-shrink: 0;

    &_quick {
      color: var(--color-green-50);
      fill: var(--color-green-50);
    }

    &_long {
      color: var(--color-orange-50);
      fill: var(--color-orange-50);
    }

    &_cancel {
      color: var(--color-red-60);
      fill: var(--color-red-60);
    }
  }
</style>
